export default (theme) => ({
  root: {
    margin: 0,
    padding: 10,
    backgroundColor: "#e8e8e8",
  },
  dialogPaper: {
    minHeight: "450px",
  },
  panelTitle: {
    fontSize: "1rem",
    fontWeight: "600",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: 0,
    color: "#525252",
  },
  chipPanel: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: 0,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  headerTop: {
    backgroundColor: "#F7F7F7",
    borderWidth: 1,
    borderColor: "#e0e0e0",
    borderStyle: "solid"
  },
  header: {
    backgroundColor: "#F7F7F7",
    textAlign: "center"
  },
  rightBorder: {
    borderRight: "1px solid #e0e0e0"
  },
  listItem: {
    listStyleType: "none"
  },
  green: {
    color: "green"
  },
  greenBold: {
    color: "green",
    fontWeight: "bold",
  },
  red: {
    color: "red"
  },
  errorText: {
    fontSize: 12,
    color: "#e30613",
  },
  inputLabel: {
    fontSize: 13,
  },
});
